<div class="row">
    <div class="col-xs-12">
        <!-- <h4 class="mt-0">Historisk utveckling av andel ytor där RASE har gynnsam konkurrensstatus</h4> -->
        <div class="subheadertext">Välj område med knapparna för att visa utvecklingen över tid och vilka år som inventerats.</div>
    </div>

    <div class="col-xs-12">
        <app-fordjupning-button-group (selectedOmradeEvent)="onOmradeSelect($event)"></app-fordjupning-button-group>
        <p><b>Valt område</b>: {{ omradeNamn$ | async }}</p>
    </div>
</div>

<div class="row">
    <div class="col-md-8 col-xs-12 col-lg-9">
        <app-rase-konkurrens-chart [inventeringar]="inventeringar$ | async" [diagramBeskrivning]="'Historisk utveckling av RASE med gynnsam status per hektar'"></app-rase-konkurrens-chart>
    </div>

    <div class="col-md-4 col-xs-12 col-lg-3">
        <ng-container *ngIf="senasteInventering$ | async as senasteInventering">
            <app-sammanvagning-card
                [inventering]="senasteInventering"
                vardeVariabel="antalRASEGynnsamHa3InvAVG"
                cardBeskrivning="RASE per hektar. Sammanvägning för de tre senaste inventeringarnaa"
                [percent]="false"
            >
                <ng-container sammanvagningCardIcon *ngIf="senasteInventering?.slutsatsRASEGynInt > 0; else elseTemplate">
                    <span class="abinicon-rase_gynnsam_status_uppfylld" role="img" aria-label="Målet är uppnått"></span>
                </ng-container>
                <ng-template sammanvagningCardIcon #elseTemplate>
                    <span class="abinicon-rase_gynnsam_status_ej_uppfylld" role="img" aria-label="Målet är inte uppnått"></span>
                </ng-template>
            </app-sammanvagning-card>
        </ng-container>
    </div>
</div>
